import { render, staticRenderFns } from "./datapush.vue?vue&type=template&id=6ae0adea&"
import script from "./datapush.vue?vue&type=script&lang=ts&"
export * from "./datapush.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "datapush.vue"
export default component.exports